<template>
	<v-tabs
		class="type-active-jobs"
		v-model="selectedTabIndex"
		@input="handleTabClick">
		<v-tab
			v-for="(jobsType, index) in JOBS_TYPES" :key="index">
			<b>{{ jobsType.label }}</b>
		</v-tab>
	</v-tabs>
</template>

<script>
import { JOBS_TYPES } from '@/modules/job-profile/constants/constants';

export default {
	name: 'selector-active-job',
	data() {
		return {
			JOBS_TYPES,
			selectedTabIndex: 0,
		};
	},
	props: ['indexTab'],
	methods: {
		handleTabClick(index) {
			this.$emit('filterJobByStatus', index);
		},
	},
	watch: {
		indexTab: {
			handler(newVal) {
				this.selectedTabIndex = newVal;
			},
		},
	},
};
</script>

<style lang="scss">
.type-active-jobs {
	.v-tabs__bar {
		background: transparent;

		.v-tabs__slider-wrapper {
			.accent {
				background: var(--app-color-primary) !important;
			}
		}

		.v-tabs__container {
			height: 30px !important;

			.v-tabs__div {
				color: var(--app-color-primary) !important;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-info-edition/selector-active-job.vue